import FeaturedOffering from './FeaturedOffering';

export default FeaturedOffering;
